import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import PortfolioProjects from './pages/portfolio-projects';
import HomeLanding from './pages/home-landing';
import ContactForm from './pages/contact-form';
import AboutExperience from './pages/about-experience';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<AboutExperience />} />
        <Route path="/portfolio-projects" element={<PortfolioProjects />} />
        <Route path="/home-landing" element={<HomeLanding />} />
        <Route path="/contact-form" element={<ContactForm />} />
        <Route path="/about-experience" element={<AboutExperience />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
